import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Switch from "@mui/material/Switch";
import EditNotificationsOutlinedIcon from "@mui/icons-material/EditNotificationsOutlined";
import routeConstant from "../../../route/compoent/routeConstant";
import { StoreContext } from "../../../store/Provider";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import "./index.css";
import { path } from "./../../constants/apiPath";
import instance from "../../common/api/interceptor";
import { NotificationManager } from "react-notifications";
import Loading from "../loading/Loading";
import NoData from "../noData/NoData";
import SliderComp from "../../common/component/slider/Slider";
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import axios from "axios";
import { baseURL } from "../../../config";

const BlueSwitch = withStyles({
  switchBase: {
    color: "#a3acc3",
    "&$checked": {
      color: "#122d76",
    },
    "&$checked + $track": {
      backgroundColor: "#122d76",
    },
  },
  checked: {},
  track: {
    backgroundColor: "#9f9f9f",
    opacity: 1,
  },
})(Switch);

function Notification() {
  const navigate = useNavigate();
  const context = useContext(StoreContext);
  const [notificationData, setNotificationData] = useState({});
  const [notifiEmail, setNotifiEmail] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getNotificationData();
  }, []);

  const getNotificationData = () => {
    setLoading(true);
    instance
      .get(path.GET_NOTIFICATION_DETAIL)
      .then(async (res) => {
        if (res.Is_Success) {
          await setNotificationData(res.data);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        setLoading(false);
      });
  };

  const onRemoveEmail = (ele, i) => {
    // const notifiDataFull = notificationData;
    // arr.push(ele);
    // var data = JSON.stringify([...arr]);
    // arr.splice(i, 1);
    if (!ele.PK) {
      const arr = [...notificationData.NotificationAdditionalEmails];
      let filteredEmails = arr.filter(function (value, index, arr) {
        return value !== ele;
      });
      console.log(filteredEmails);
      setNotificationData((prev) => ({
        ...prev,
        NotificationAdditionalEmails: [...filteredEmails],
      }));
    } else {
      // notifiDataFull.NotificationAdditionalEmails = [...filteredEmails];
      const arr = [];
      arr.push(ele);
      // var data = JSON.stringify([...arr]);
      instance
        .post(path.REMOVE_EMAIL_NOTIFY, arr)
        .then((res) => {
          if (res.Is_Success) {
            setNotificationData({});
            NotificationManager.success(res.Message, "", 3000);
            getNotificationData();
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });

      // notifiDataFull.NotificationAdditionalEmails = [...filteredEmails];
      // if (notificationData.PK === "00000000-0000-0000-0000-000000000000") {
      //   instance
      //     .post(path.SUBSCRIBE_NOTIFY, notifiDataFull)
      //     .then(async (res) => {
      //       if (res.Is_Success) {
      //         setNotificationData({});
      //         NotificationManager.success(res.Message, "", 3000);
      //         getNotificationData();
      //       } else {
      //         NotificationManager.error(res.Message, "", 3000);
      //       }
      //     })
      //     .catch((err) => {
      //       console.error(err);
      //       if (err.response) {
      //       } else if (err.request) {
      //       } else if (err.message) {
      //       } else {
      //         NotificationManager.error("Something went wrong!", "", 3000);
      //       }
      //     });
      // } else {
      //   instance
      //     .patch(path.SUBSCRIBE_NOTIFY, notifiDataFull)
      //     .then(async (res) => {
      //       if (res.Is_Success) {
      //         setNotificationData({});
      //         NotificationManager.success(res.Message, "", 3000);
      //         getNotificationData();
      //       } else {
      //         NotificationManager.error(res.Message, "", 3000);
      //       }
      //     })
      //     .catch((err) => {
      //       console.error(err);
      //       if (err.response) {
      //       } else if (err.request) {
      //       } else if (err.message) {
      //       } else {
      //         NotificationManager.error("Something went wrong!", "", 3000);
      //       }
      //     });
      // }
    }
    // axios({
    //   method: "post",
    //   url: "https://dashboard.mts-logistics.com/orderManagementApiDEV/api/v1/Notifications/deleteAdditionalEmails",
    //   data: data
    // })
  };

  const onUpdateNotification = () => {
    setLoading(true);
    if (notificationData.PK === "00000000-0000-0000-0000-000000000000") {
      instance
        .post(path.SUBSCRIBE_NOTIFY, notificationData)
        .then(async (res) => {
          if (res.Is_Success) {
            setNotificationData({});
            NotificationManager.success(res.Message, "", 3000);
            getNotificationData();
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
          setLoading(false);
        });
    } else {
      instance
        .patch(path.SUBSCRIBE_NOTIFY, notificationData)
        .then(async (res) => {
          if (res.Is_Success) {
            setNotificationData({});
            NotificationManager.success(res.Message, "", 3000);
            getNotificationData();
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
          setLoading(false);
        });
    }
  };

  return (
    <div className="_notificationSetting">
      <div className="_notificationSettingHeader">
        {/* <h5>Notification Settings</h5> */}
        <Button
          title={"Close"}
          onClick={() =>
            context.setNotificationOpen({
              open: false,
              type: "",
              reload: false,
            })
          }
        >
          <CloseIcon />
        </Button>
      </div>
      {loading ? (
        <Loading />
      ) : !Object.keys(notificationData).length ? (
        <NoData>No data found!</NoData>
      ) : (
        <div className="_notificationBody">
          <div className="_notifiGeneralData">
            <FormControlLabel
              className="_notifiFormControlLabel"
              labelPlacement="start"
              control={
                <BlueSwitch
                  checked={notificationData.Issubscribe}
                  onChange={() =>
                    setNotificationData((prev) => ({
                      ...prev,
                      Issubscribe: !notificationData.Issubscribe,
                    }))
                  }
                  name="Issubscribe"
                />
              }
              label="Subscribe"
            />
          </div>
          <div className="_notifiNoticationEvents">
            {notificationData.noticationEvents.map((ele, i) => {
              console.log(ele);
              if (ele.NotificationEventCode === "UPP") {
                return null;
              }
              return (
                <FormControlLabel
                  key={i}
                  className="_notifiFormControlLabel"
                  labelPlacement="start"
                  control={
                    <BlueSwitch
                      checked={ele.NotificationEvent_IsTicked}
                      onChange={() => {
                        if (notificationData.Issubscribe) {
                          const arr = [...notificationData.noticationEvents];
                          arr[i].NotificationEvent_IsTicked =
                            !arr[i].NotificationEvent_IsTicked;
                          setNotificationData((prev) => ({
                            ...prev,
                            noticationEvents: [...arr],
                          }));
                        }
                      }}
                      name={ele.NotificationEventDescription}
                    />
                  }
                  label={ele.NotificationEventDescription}
                />
              );
            })}
          </div>
          <div className="_notifiNotificationAdditionalEmailsHeading">
            <h6>Email List</h6>
          </div>
          {notificationData?.NotificationAdditionalEmails.length
            ? notificationData?.NotificationAdditionalEmails.map((ele, i) => {
                return (
                  <div className="_notifiNotificationAdditionalEmails input_email_div">
                    <p className="form-control">{ele.AdditionalEmail}</p>
                    {
                      <Button onClick={(i) => onRemoveEmail(ele, i)}>
                        <RemoveCircleIcon />
                      </Button>
                    }
                  </div>
                );
              })
            : null}
          <div className="_notifiNotificationAdditionalEmails input_div_padd">
            <input
              type="text"
              className="form-control"
              value={notifiEmail}
              placeholder={"Enter Email"}
              onChange={(e) => {
                setNotifiEmail(e.target.value);
              }}
            />
            <Button
              onClick={() => {
                if (notificationData.NotificationAdditionalEmails.length < 5) {
                  const alreadyExist =
                    notificationData.NotificationAdditionalEmails.some(
                      (el) => el.AdditionalEmail === notifiEmail
                    );
                  if (alreadyExist) {
                    NotificationManager.error("Email already exist", "", 3000);
                  } else {
                    if (notifiEmail) {
                      if (
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                          notifiEmail
                        )
                      ) {
                        const arr = [
                          ...notificationData.NotificationAdditionalEmails,
                        ];
                        arr.push({
                          AdditionalEmail: notifiEmail,
                        });
                        setNotificationData((prev) => ({
                          ...prev,
                          NotificationAdditionalEmails: [...arr],
                        }));
                        setNotifiEmail("");
                      } else {
                        NotificationManager.error(
                          "Please fill valid Email",
                          "",
                          3000
                        );
                      }
                    } else {
                      NotificationManager.error("Please fill Email", "", 3000);
                    }
                  }
                } else {
                  NotificationManager.error(
                    "Cann't add more than 5 Emails",
                    "",
                    3000
                  );
                }
              }}
            >
              <AddCircleIcon />
            </Button>
          </div>
          <div className="_solidButton w-100 py-2 mt-auto">
            <Button variant="contained" onClick={onUpdateNotification}>
              Save
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Notification;
